import React from "react";
import { Button, Modal } from "antd";
import { LOSE_FEATURES } from "../../../util/constants";
import './LoseAccessWarningModal.scss';

interface LoseAccessWarningModalProps {
  visible: boolean;
  onClose: () => void;
  onOk: () => void;
}

export default function LoseAccessWarningModal({ visible, onClose, onOk }: LoseAccessWarningModalProps) {

  return (
    <Modal className={"lose-access-warning-modal clean one"} open={visible} destroyOnClose={true}>
      <header>
        <h2>Please note!</h2>
        <h2>You will lose access to Pro features:</h2>
      </header>
      <section>
        <ul>
          {LOSE_FEATURES.map((feature) => <li key={feature}>{feature}</li>)}
        </ul>
        <span>Plus add-ons for: Display, Users, Locations</span>
      </section>
      <footer>
        <Button size={'large'} className={'secondary'} onClick={onClose}>Exit</Button>
        <Button size={'large'} className={'primary'} onClick={onOk}>Continue</Button>
      </footer>

    </Modal>
  );
}
